<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16354Oi/tc-custom/9781526784087.jpg?1728327053872" alt="This image is the cover for the book Killer of the Princes in the Tower"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Killer of the Princes in the Tower
      </h1>
      <p class="bookDescription body article font2">
        <b>A new investigation into the most infamous crime of the Middle Ages: the supposed murders of Edward V and his brother Richard of York in the 15th century.</b><br/><br/>The disappearance of two boys during the summer of 1483 has never been satisfactorily explained. They were Edward, Prince of Wales, nearly thirteen at the time, and his brother, Richard of York, nearly ten. With their father, Edward IV, dying suddenly at forty, both boys had been catapulted into the spotlight of fifteenth-century politics, which was at once bloody and unpredictable. <br/><br/>Over the past 500 years, three men in particular have been accused of the boys’ murders—Richard of Gloucester; Henry Tudor, Earl of Richmond; and Henry Stafford, Duke of Buckingham. Thanks to the work of the hack “historians” who wrote for Henry VII, the first Tudor, generations grew up believing that the boys were murdered and that the guilty party was their wicked uncle, Richard, who crowned himself King of England in July 1483, at which time the boys were effectively prisoners in the Tower of London. <br/><br/>After that, there was no further sign of them. <br/><br/>This book takes a different approach, the first to follow this particular line of enquiry. It is written as a police procedural, weighing up the historical evidence without being shackled to a particular “camp.” The supposition has always been made that the boys were murdered for political reasons. But what if that is incorrect? What if they died for other reasons entirely? What if their killer had nothing to gain politically from their deaths at all? <br/><br/>And, even more fascinatingly, what if the princes in the Tower were not the only victims?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        M. J. Trow
      </h2>
      
      <p class="authorDescription body article">M.J. Trow was educated as a military historian at King’s College, London and is probably best known today for his true crime and crime fiction works. He has always been fascinated by Richard III and, following on from Richard III in the North, also by Pen and Sword, has hopefully finally scotched the rumour that Richard III killed the princes in the Tower. He divides his time between homes in the Isle of Wight and the Land of the Prince Bishops.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22910680